import React, {useContext, useEffect} from 'react'
import {
    Router,
    Redirect,
    Route as ReactRoute,
    Switch,
} from "react-router-dom"
import ModeView from './mode/ModeView'
import LoginView from './LoginView';
import ForgetPasswordView from './ForgetPasswordView';
import FailLandView from './FailLandView';
import LandingView from './LandingView';
import history from '../history'

import {SocketContext} from "../context/socket";
import {useAuth} from "../lib/auth";
import {toggleBackdrop} from "../reducers/coreSlice";
import {useDispatch} from "react-redux";

// Private Route (Require Login)
const PrivateRoute = (props) => {
    const {isAuthenticated} = useAuth()


    return (
        <ReactRoute {...props} >
            {
                isAuthenticated ?
                    props.children : 
                    <Redirect to={{ pathname: "/login"}}/>
            }
        </ReactRoute>
    )
}

// Normal Route
const Route = (props) => {
    return (
                <ReactRoute {...props} >
                    {props.children}
                </ReactRoute>
            )
}

const Routes = () => {
    const dispatch = useDispatch()
    const socket = useContext(SocketContext)

    const handleSocketPost = (event) => {
        history.push(`/${event.mode}/post/${event.post_code}`)
    }

    const handleSocketSystemPage = (event) => {
        if (event !== 'object') event = JSON.parse(event)

        let url = `/${event.mode}/system/${event.system_code}`;
        if(event.building_code){
            url = `/${event.mode}/building/${event.building_code}/system/${event.system_code}`
        }
        history.push(url)
    }

    const handleSocketMode = (mode) => {
        history.push(`/${mode}`);
    }

    const handleSocketBuilding = (event) => {
        history.push(`/${event.mode}/building/${event.building_code}`);
    }

    const handleSocketApplication = (event) => {
        window.open(event, "_blank");
    }

    const handleSocketBackdrop = (event) => {
        console.log("BACKDROP_OUT")
        dispatch(toggleBackdrop())
    }

    useEffect(() => {
        if(socket) {
            // Socket command to Route for mode selected
            socket.on("CHANGE_MODE_OUT", handleSocketMode)

            // Socket command to Route for building selected
            socket.on("BUILDING_OUT", handleSocketBuilding)

            // TODO: Missing mode in event
            // Socket command to Route for post selected
            socket.on("POST_OUT", handleSocketPost)

            // Socket command to Route for building view and pages
            // TODO: Need to test
            socket.on("SYSTEM_PAGE_OUT", handleSocketSystemPage)

            // Socket command to trigger Application
            socket.on("APPLICATION_SYSTEM_OUT", handleSocketApplication)

            // Socket command to trigger Backdrop
            socket.on("BACKDROP_OUT", handleSocketBackdrop)
        }

        return () => {
            if(socket) {
                socket.off("CHANGE_MODE_OUT", handleSocketPost);
                socket.off("BUILDING_OUT", handleSocketBuilding);
                socket.off("POST_OUT", handleSocketPost);
                socket.off("SYSTEM_PAGE_OUT", handleSocketSystemPage);
                socket.off("APPLICATION_SYSTEM_OUT", handleSocketApplication)
            }
        }


    },[socket])


    return (
        <Router history={history}>
            <Switch>
                <Route path={`/login`}><LoginView/></Route>
                <Route path={`/landing`}><LandingView/></Route>
                <Route path={`/failland`}><FailLandView/></Route>
                <Route path={`/forget`}><ForgetPasswordView/></Route>
                <PrivateRoute path={`/:mode`}><ModeView /></PrivateRoute>
                <Redirect path="/" to={"/daily"} />
            </Switch>
        </Router>
    )   
}

export default Routes